import axios from "axios";
import { getToken } from "../common/routines/user-operations";

import { routes } from "../constants/routes";
import { useMsal } from "@azure/msal-react";
import { serverAddress } from "./env";
import Cookies from "js-cookie";

/**
 * Creates a configured Axios instance:
 * - Injects Authorization header from getToken
 * - Aligns baseURL with current environment
 * - Handles 401 by clearing storage/caches and redirecting to UNAUTHORIZED
 */
const setupAxios = () => {
  const baseURL = serverAddress.toString() || "";

  const instance = axios.create({
    baseURL,
  });
  instance.interceptors.request.use(async (config) => {
    const customConfig = config;
    const appBaseURL = serverAddress.toString() || "";

    customConfig.baseURL = appBaseURL;
    customConfig.headers["Access-Control-Allow-Origin"] = "*";
    if (config.url !== "/login/postSSOValidation") {
      customConfig.headers.Authorization = getToken();
    }
    return customConfig;
  });

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error?.response?.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        Cookies.remove("userDetails");
        globalThis.location.href = routes.LANDING;
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });

        if ("caches" in globalThis) {
          caches.keys().then((names) => {
            for (let name of names) caches.delete(name);
          });
        }
        localStorage.clear();
        sessionStorage.clear();
        Cookies.remove("userDetails");
        globalThis.location.href = routes.LANDING;
        const { instance } = useMsal();
        instance.clearCache();
      }

      return error;
    },
  );

  return instance;
};

export default setupAxios;
